"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react")); // Import FC for Functional Component type
const styled_components_1 = __importStar(require("styled-components")); // Import DefaultTheme for theme typing
const material_1 = require("@mui/material");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const translations_1 = __importDefault(require("../../../common/translations"));
const DialogContentWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 100px;
  height: 100%;
  width: 100%;
  max-width: 700px;
  padding: 20px;
  margin-top: 10vmin;
  text-align: center;

  @media (orientation: portrait) {
    justify-content: center;
  }
`;
const DialogTitle = (0, styled_components_1.default)(material_1.Typography).attrs({ variant: 'h3', component: 'h2' }) `
  color: white;
`;
const LocalesList = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3vmin;
  width: 100%;
  max-width: 400px;
`;
const LanguageButton = styled_components_1.default.button `
  border-radius: 100px;
  padding: 15px 30px;
  font-size: 24px;
  width: 100%;
  border: 1px solid rgba(247, 243, 242, 1);
  text-align: center;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  background-color: transparent;
  color: white;

  ${props => {
    var _a, _b, _c;
    return props.isActive &&
        (0, styled_components_1.css) `
      color: ${(_c = (_b = (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.mainAppColor) === null || _b === void 0 ? void 0 : _b.main) !== null && _c !== void 0 ? _c : '#000000'};
      background-color: rgba(247, 243, 242, 1);
    `;
}}

  &:hover, &:focus-visible {
    background-color: ${props => (props.isActive ? 'rgba(247, 243, 242, 0.9)' : 'rgba(255, 255, 255, 0.1)')};
    outline: none;
  }

  &:focus-visible {
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
  }

  @media (max-width: 600px) {
    font-size: 20px;
    padding: 12px 25px;
  }
`;
const StyledCloseButton = (0, styled_components_1.default)(material_1.IconButton) `
  position: absolute;
  top: 16px;
  right: 16px;
  background-color: rgba(255, 255, 255, 0.7);
  color: black;

  @media (orientation: portrait) {
    top: 35%;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.9);
  }
`;
const LanguagePickerModal = ({ open, onClose, enabledLocales, currentLocale, onLocaleSelect, }) => {
    const theme = (0, material_1.useTheme)();
    const handleLocaleClick = (localeAbbreviation) => {
        onLocaleSelect(localeAbbreviation);
        onClose();
    };
    const sortedLocales = (0, react_1.useMemo)(() => {
        return enabledLocales
            .filter(locale => typeof (locale === null || locale === void 0 ? void 0 : locale.name) === 'string' && locale.name.trim() !== '')
            .sort((a, b) => a.name.localeCompare(b.name));
    }, [enabledLocales]);
    return (react_1.default.createElement(material_1.Dialog, { open: open, onClose: onClose, fullScreen: true, PaperProps: {
            sx: {
                backgroundColor: 'transparent',
                boxShadow: 'none',
                color: 'white',
                alignItems: 'center',
            },
        }, BackdropProps: {
            sx: {
                backdropFilter: 'blur(54.36563491821289px)',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
            },
        } },
        react_1.default.createElement(StyledCloseButton, { "aria-label": "close language selection", onClick: onClose },
            react_1.default.createElement(Close_1.default, null)),
        react_1.default.createElement(DialogContentWrapper, null,
            react_1.default.createElement(DialogTitle, null, translations_1.default.t('choose_a_lanugauge_title')),
            react_1.default.createElement(LocalesList, null, sortedLocales.map(locale => (react_1.default.createElement(LanguageButton, { key: locale.abbreviation, theme: theme, isActive: locale.abbreviation === currentLocale, onClick: () => handleLocaleClick(locale.abbreviation) }, locale.name)))))));
};
exports.default = LanguagePickerModal;
